import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { PoiSteps } from "@/helpers/poiHelper";

export default {
  name: "StepConfigDialog",
  data: () => ({
    steps: PoiSteps
  }),
  props: ["showDialog", "items", "infoHeading", "infoText"],
  components: { InfoDialog },
  computed: {
    cShowDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        if (!val) this.$emit("close");
      }
    }
  },
  methods: {
    getCheckboxValue(stepId, categoryGroup) {
      return categoryGroup?.poiSteps?.includes(stepId);
    },
    setStep(checkboxValue, stepId, item) {
      if (!Array.isArray(item?.poiSteps)) item.poiSteps = [];
      if (!checkboxValue && item?.poiSteps?.includes(stepId))
        item.poiSteps.remove(stepId);
      else if (checkboxValue && !item?.poiSteps?.includes(stepId))
        item.poiSteps.push(stepId);
    },
    checkCategoryGroup(stepId, item) {
      return item?.categoryGroup?.poiSteps?.includes(stepId);
    }
  }
};
